import { Util } from '@libs/utilities/util';
import { Stats, TypeStatsDataPoint } from '@libs/utilities/stats';

import { IAmazonCompositeKeywordData } from '../../../../constants/research';


export class CompetitionScoreEvaluatorService {

	//** Configurations */
	private readonly COMPETITIVENESS_CURVE: TypeStatsDataPoint[] = [
		[0, 	  0],
		[1000,	  0.1],
		[70000,   0.95],
		[100000,  1],
		[1000000, 1]
	];


	competitiveness(keywordData: IAmazonCompositeKeywordData): number {

		//0 - keep the API value inside the range covered by the competitiveness curve
		const minimumProducts	: number = this.COMPETITIVENESS_CURVE[0][0];
		const maximumProducts	: number = this.COMPETITIVENESS_CURVE[this.COMPETITIVENESS_CURVE.length - 1][0];
		const totalProducts		: number = Util.Number.toSaveNumber(
			Util.Number.toNumber(keywordData.amazon.competition.totalProducts, minimumProducts),
			minimumProducts,
			maximumProducts
		);

		//1 - fit competitiveness curve and predict
		const predictedCompetitiveness: number = Stats.Regression.linearRangeFit(this.COMPETITIVENESS_CURVE, totalProducts);

		//2 - obfuscate the value
		const obfuscatedValue: number = Util.Crypto.obfuscateBy5Percent(predictedCompetitiveness);
		return Util.Number.roundDouble(Util.Number.toSaveNumber(obfuscatedValue, 0, 1));
	}
}
